import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import CollectionForm from './CollectionForm';
import FieldSection from '../fields/FieldSection';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import DocsLink from '../../../common/custom/DocsLink';
import ParentDocCard from '../../common/ParentDocCard';
import { fieldToShow } from 'drapcode-constant';
import ReactJson from 'react-json-view';
export class CollectionSettingCard extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    collections: PropTypes.object.isRequired,
  };
  state = { activeTab: 'collection', toggleFields: false };
  toggle = (activeTab) => {
    this.setState({ activeTab: activeTab });
  };
  toggleField = (value) => {
    this.setState({ toggleFields: value });
  };
  showCollectionForm = () => {
    const {
      actions,
      collections,
      projectId,
      history,
      homeActions,
      collection,
      version,
      collectionFlag,
      fieldFlag,
      snippets,
    } = this.props;
    const {
      selectedCollection,
      projectCollections,
      createCollectionPending,
      updateCollectionsPending,
      deleteCollectionPending,
      createNewFieldPending,
      deleteFieldPending,
      currentCollectionListPage,
      totalCollectionPages,
      isOpenCollectionUpdateModel,
      projectDetail,
      generateCrudPagesPending,
    } = collections;
    const { collectionTitle, fields } = selectedCollection ? selectedCollection : {};
    const showCollectionLoader = createCollectionPending || updateCollectionsPending;
    const fieldsToShow = fields.filter((field) => fieldToShow(field.type));
    const fieldObj = {};
    fieldsToShow.forEach((field) => {
      fieldObj[field.fieldTitle.en] = field.fieldName;
    });
    //TODO: Parent Card handling
    return (
      <Fragment>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('list')}`}></i>
                </div>
                <div className="card-content">
                  {fields.length > 0 && (
                    <FieldSection
                      actions={actions}
                      collection={selectedCollection}
                      projectId={projectId}
                      version={version}
                      projectCollections={projectCollections}
                      showCollectionFieldLoader={createNewFieldPending}
                      showCollectionFieldDeleteLoader={deleteFieldPending}
                      generateCrudPagesPending={generateCrudPagesPending}
                      isOpenCollectionUpdateModel={isOpenCollectionUpdateModel}
                      homeActions={homeActions}
                      showCollectionLoader={showCollectionLoader}
                      showCollectionDeleteLoader={deleteCollectionPending}
                      history={history}
                      currentCollectionListPage={currentCollectionListPage}
                      totalCollectionPages={totalCollectionPages}
                      toggleField={this.toggleField}
                      projectDetail={projectDetail}
                      collectionFlag={collectionFlag}
                      fieldFlag={fieldFlag}
                      snippets={snippets}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <ParentDocCard>
            <h5>
              <b>Manage collection</b>
            </h5>
            <p>
              After creating a collection, you can easily add as many fields in it, edit or delete
              them as you want.
            </p>
            <DocsLink link="https://academy.drapcode.com/docs/app-collection/manage-collection" />
            <br />
            <h5>
              <b>About Child Of Field in Collections</b>
            </h5>
            <p>
              Child of field in collections allows you to bind two fields of different collections
              in a parent-child relation. When data gets added in the parent field, it automatically
              gets reflected in the child field as well.
            </p>
            <DocsLink link="https://academy.drapcode.com/docs/app-collection-fields/child-of-field" />
          </ParentDocCard>
        </div>
        <Modal
          isOpen={isOpenCollectionUpdateModel}
          toggle={() => {
            actions.toggleCollectionUpdate();
          }}
          backdrop="static"
          style={this.state.toggleFields ? { maxWidth: '800px', marginTop: '70px' } : {}}
        >
          <ModalHeader
            toggle={() => {
              actions.toggleCollectionUpdate();
            }}
            className="border-bottom"
          >
            <strong>
              {this.state.toggleFields ? `${collectionTitle} Fields` : `Update Collection Details`}
            </strong>
          </ModalHeader>
          <ModalBody>
            {this.state.toggleFields ? (
              <ReactJson
                name={false}
                iconStyle={'triangle'}
                enableClipboard={false}
                src={fieldObj}
                theme="rvj-default"
                collapsed={false}
              />
            ) : (
              <CollectionForm
                actions={actions}
                version={version}
                homeActions={homeActions}
                projectId={projectId}
                collection={selectedCollection}
                showCollectionLoader={showCollectionLoader}
                showCollectionDeleteLoader={deleteCollectionPending}
                projectCollections={projectCollections}
                history={history}
                currentCollectionListPage={currentCollectionListPage}
                totalCollectionPages={totalCollectionPages}
              />
            )}
          </ModalBody>
        </Modal>
      </Fragment>
    );
  };

  showCollectionDetailToEdit = () => {
    const { collections, projectId } = this.props;
    const { selectedCollection } = collections;
    if (projectId && selectedCollection) {
      return this.showCollectionForm();
    }
  };

  render() {
    const { selectedCollection } = this.props.collections;
    if (selectedCollection) {
      return (
        <div className="row">
          <div className="col-12"> {this.showCollectionDetailToEdit()} </div>
        </div>
      );
    }

    return (
      <div className="row">
        <div className="title">
          <h2>Loading ...</h2>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionSettingCard);
